const sidebar = (state = false, action) => {
    switch (action.type) {
        case 'TOGGLE_SIDEBAR':
            return action.status
        default: return state;
    }
};

export default sidebar;
